import { commitOptions } from "./commitSeams";
import { api } from "@/lib/api/client";
import type { StudentProfile, StudentVersions, ExpectedStudentVersions } from "@/lib/api/students";

/** Self-service: the only fields a student may edit on their own record. */
export interface SelfStudentUpdate {
  preferred_name?: string | null;
  phone?: string | null;
  address?: string | null;
}

/** The learner's own record, with the versions a self-edit is checked against. */
export type SelfStudentProfile = StudentProfile & StudentVersions;

export function getStudentMe(): Promise<SelfStudentProfile> {
  return api.get<SelfStudentProfile>("/students/me");
}

export function patchStudentMe(
  body: SelfStudentUpdate & ExpectedStudentVersions,
  key: string,
): Promise<SelfStudentProfile> {
  return api.patch<SelfStudentProfile>("/students/me", body, commitOptions(key));
}
